export default function FixedPageWrapper({ children }) {
  return (
    <div className="bg-background-light dark:bg-background-dark text-text-light dark:text-text-dark h-screen flex flex-col items-center justify-center">
      {children}
    </div>
  );
}
